import { render } from "./AddComputeOffering.vue?vue&type=template&id=c8a374ea&scoped=true"
import script from "./AddComputeOffering.vue?vue&type=script&lang=js"
export * from "./AddComputeOffering.vue?vue&type=script&lang=js"

import "./AddComputeOffering.vue?vue&type=style&index=0&id=c8a374ea&scoped=true&lang=scss"

import exportComponent from "/jenkins/workspace/acs-centos8-pkg-builder/dist/rpmbuild/BUILD/cloudstack-4.19.3.0/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c8a374ea"]])

export default __exports__